import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import axios from "axios";
import { Toaster } from "sonner";
import { LayoutDashboard, Package, AlertCircle, CheckCircle, FileCheck } from "lucide-react";
import Dashboard from "./pages/Dashboard";
import ProductsPage from "./pages/ProductsPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Sidebar({ stats }) {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo-container">
          <img src="/villalogo.png" alt="Villa Contabilidade" className="sidebar-logo" draggable="false" />
        </div>
      </div>

      <div className="sidebar-nav">
        <Link to="/resumo-de-produtos" className={`nav-item ${isActive('/resumo-de-produtos') ? 'active' : ''}`}>
          <LayoutDashboard className="nav-item-icon" size={20} />
          <span className="nav-item-text">Resumo</span>
        </Link>
        
        <div className="nav-divider"></div>
        
        <Link to="/todos-produtos" className={`nav-item ${isActive('/todos-produtos') ? 'active' : ''}`}>
          <Package className="nav-item-icon" size={20} />
          <span className="nav-item-text">Todos os Produtos</span>
          {stats && <span className="nav-item-count">{stats.total_produtos.toLocaleString()}</span>}
        </Link>
        
        <Link to="/produtos-a-corrigir" className={`nav-item ${isActive('/produtos-a-corrigir') ? 'active' : ''}`}>
          <AlertCircle className="nav-item-icon" size={20} />
          <span className="nav-item-text">Precisam Correção</span>
          {stats && <span className="nav-item-count">{stats.pendentes_correcao.toLocaleString()}</span>}
        </Link>
        
        <Link to="/produtos-cadastrados-corretamente" className={`nav-item ${isActive('/produtos-cadastrados-corretamente') ? 'active' : ''}`}>
          <CheckCircle className="nav-item-icon" size={20} />
          <span className="nav-item-text">Cadastrados Corretamente</span>
          {stats && <span className="nav-item-count">{stats.produtos_corretos.toLocaleString()}</span>}
        </Link>
        
        <Link to="/corrigidos" className={`nav-item ${isActive('/corrigidos') ? 'active' : ''}`}>
          <FileCheck className="nav-item-icon" size={20} />
          <span className="nav-item-text">Corrigidos</span>
          {stats && <span className="nav-item-count">{stats.ja_corrigidos.toLocaleString()}</span>}
        </Link>
      </div>

      <div className="client-badge">
        <div className="client-badge-title">Cliente</div>
        <div className="client-badge-name">DROGARIA NOBRE ROCHA</div>
        <div className="client-badge-cnpj">53.062.488/0001-04</div>
      </div>
    </aside>
  );
}

function AppContent() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/estatisticas`);
      setStats(response.data);
    } catch (error) {
      console.error("Erro ao buscar estatísticas:", error);
    }
  };

  return (
    <div className="app-container">
      <Sidebar stats={stats} />
      
      <main className="main-content">
        <div className="content-area">
          <Routes>
            <Route path="/" element={<Navigate to="/resumo-de-produtos" replace />} />
            <Route path="/resumo-de-produtos" element={<Dashboard />} />
            <Route path="/todos-produtos" element={<ProductsPage tipo={null} titulo="Todos os Produtos" />} />
            <Route path="/produtos-a-corrigir" element={<ProductsPage tipo="incorretos" titulo="Produtos que Precisam de Correção" />} />
            <Route path="/produtos-cadastrados-corretamente" element={<ProductsPage tipo="corretos" titulo="Produtos Cadastrados Corretamente" />} />
            <Route path="/corrigidos" element={<ProductsPage tipo="ja_corrigidos" titulo="Produtos Já Corrigidos" />} />
          </Routes>
        </div>
      </main>

      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
